import moment from 'moment';
import { TREINADOR_ADORO_CODIGO } from './perfilId';

const getAdoroCodigoChallengePeriod = (userProfile, selectedDate) => {
    const reference = moment(selectedDate);
    const minimumChallengeDate = reference.clone().startOf('month');
    const maximumChallengeDate = reference.clone().endOf('month');

    const isInSelectedMonth =
        reference.isSameOrAfter(minimumChallengeDate, 'day') &&
        reference.isSameOrBefore(maximumChallengeDate, 'day');

    if (isInSelectedMonth && userProfile === TREINADOR_ADORO_CODIGO) {
        return true;
    }

    return false;
};

export default getAdoroCodigoChallengePeriod;
